'use strict';

module.exports = require('./Trigger');


//////////////////
// WEBPACK FOOTER
// ./~/._rc-trigger@1.10.4@rc-trigger/lib/index.js
// module id = 11
// module chunks = 0